var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2CC7B"
    },
    d: "M415.981,35.884L371.846,5.329c-8.835,9.673-23.674,11.573-34.744,3.909L115.946,328.678 c11.07,7.664,14.515,22.222,8.571,33.896l44.134,30.555c8.835-9.673,23.674-11.573,34.744-3.909l0,0 c11.07,7.664,14.515,22.222,8.571,33.896l44.134,30.555c8.835-9.673,23.674-11.573,34.744-3.909l0,0l0,0l221.156-319.441l0,0l0,0 c-11.07-7.664-14.515-22.222-8.571-33.896l-44.134-30.555c-8.835,9.673-23.674,11.573-34.744,3.909l0,0 C413.482,62.116,410.037,47.557,415.981,35.884z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.338,
    y: 179.547,
    transform: "matrix(-0.5692 0.8222 -0.8222 -0.5692 674.5125 157.6328)",
    style: {
      fill: "#F25F60"
    },
    width: 265.243,
    height: 151.957
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2F2F2"
    },
    points: "256.373,228.127 293.411,239.236 315.422,207.443 316.302,246.101 353.341,257.211  316.846,269.994 317.726,308.652 294.291,277.894 257.797,290.678 279.808,258.885 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M246.757,447.205L330.432,90.62l-26.15-6.136l2.222-23.093l-4.738-1.111 L115.946,328.678c11.07,7.664,14.515,22.222,8.571,33.896l44.135,30.555c8.834-9.673,23.674-11.573,34.744-3.909l0,0 c11.07,7.664,14.515,22.222,8.571,33.896L246.757,447.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD782"
    },
    d: "M171.916,59.353L119.657,47.09c-4.677,12.236-17.789,19.441-30.896,16.365L0,441.707 c13.107,3.076,21.647,15.36,20.393,28.401l52.259,12.263c4.677-12.236,17.789-19.441,30.896-16.365l0,0 c13.107,3.076,21.647,15.36,20.393,28.401l52.259,12.263c4.677-12.236,17.789-19.441,30.896-16.365l0,0l0,0l88.759-378.251l0,0l0,0 c-13.107-3.075-21.647-15.36-20.393-28.401L223.204,71.39c-4.677,12.236-17.789,19.441-30.896,16.365l0,0 C179.2,84.677,170.662,72.394,171.916,59.353z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6465"
    },
    d: "M92.641,131.118c-0.652,0-1.316-0.075-1.979-0.23l-16.802-3.943 c-4.64-1.088-7.519-5.732-6.429-10.372c1.088-4.639,5.732-7.519,10.372-6.429l16.802,3.943c4.64,1.088,7.519,5.732,6.429,10.372 C100.103,128.434,96.556,131.118,92.641,131.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6465"
    },
    d: "M231.436,163.686c-0.652,0-1.315-0.075-1.979-0.23l-34.699-8.143 c-4.64-1.088-7.519-5.732-6.429-10.372c1.088-4.639,5.729-7.519,10.372-6.429l34.699,8.143c4.64,1.088,7.519,5.732,6.429,10.372 C238.898,161.003,235.352,163.686,231.436,163.686z M162.039,147.402c-0.652,0-1.315-0.075-1.979-0.23l-34.699-8.143 c-4.64-1.088-7.519-5.732-6.429-10.372c1.088-4.64,5.73-7.519,10.372-6.429l34.699,8.143c4.64,1.088,7.519,5.732,6.429,10.372 C169.5,144.719,165.955,147.402,162.039,147.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6465"
    },
    d: "M282.937,175.772c-0.652,0-1.316-0.075-1.979-0.23l-16.802-3.943 c-4.64-1.088-7.519-5.732-6.429-10.372c1.088-4.639,5.733-7.519,10.372-6.429l16.802,3.943c4.64,1.088,7.519,5.732,6.429,10.372 C290.398,173.089,286.853,175.772,282.937,175.772z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.095,
    y: 231.729,
    transform: "matrix(-0.2285 0.9735 -0.9735 -0.2285 472.4484 241.0186)",
    style: {
      fill: "#FF6465"
    },
    width: 265.257,
    height: 151.965
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "93.83,296.702 132.362,293.47 141.197,255.825 156.177,291.473 194.71,288.241  165.436,313.505 180.416,349.154 147.343,329.119 118.069,354.383 126.903,316.737 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F25F60"
    },
    d: "M319.075,74.214c-1.695,0-3.406-0.497-4.904-1.535l-14.19-9.824 c-3.919-2.713-4.896-8.089-2.183-12.007c2.713-3.919,8.09-4.896,12.007-2.183l14.19,9.824c3.919,2.713,4.896,8.089,2.183,12.007 C324.502,72.916,321.811,74.214,319.075,74.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F25F60"
    },
    d: "M436.29,155.365c-1.695,0-3.406-0.498-4.904-1.535l-29.304-20.288 c-3.919-2.713-4.896-8.089-2.183-12.006c2.713-3.919,8.089-4.896,12.007-2.183l29.304,20.288c3.919,2.713,4.896,8.089,2.183,12.006 C441.717,154.066,439.026,155.365,436.29,155.365z M377.683,114.789c-1.695,0-3.406-0.498-4.904-1.535l-29.304-20.288 c-3.919-2.713-4.896-8.089-2.183-12.006c2.713-3.919,8.09-4.896,12.007-2.183l29.304,20.288c3.919,2.713,4.896,8.089,2.183,12.007 C383.11,113.491,380.419,114.789,377.683,114.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F25F60"
    },
    d: "M479.783,185.477c-1.695,0-3.406-0.498-4.904-1.535l-14.19-9.824 c-3.919-2.713-4.896-8.089-2.183-12.007c2.713-3.919,8.09-4.896,12.007-2.183l14.19,9.824c3.919,2.713,4.896,8.089,2.183,12.007 C485.211,184.178,482.519,185.477,479.783,185.477z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.aacf033db94cee771945fa9c17bb9347.svg";
export { ForwardRef as ReactComponent };